export const SIGN_UP_EVENTS = {
  VIEW_SIGNUP_PERSONAL_INFO: 'view_signup_personal_info',
  SELECT_SIGNUP_GO_TO_SIGNIN: 'select_signup_go_to_signin',
  SELECT_SIGNUP_PERSONAL_INFO_CONTINUE: 'select_signup_personal_info_continue',
  VIEW_SIGNUP_EMAIL_PASSWORD: 'view_signup_email_password',
  SELECT_SIGNUP_EMAIL_PASSWORD_CONTINUE:
    'select_signup_email_password_continue',
  SELECT_CHECKBOX_OPT_IN_MARKETING_CAMPAIGNS:
    'select_checkbox_opt_in_marketing_campaigns',
  API_INVITATION_CODE_PRELOAD_INFO_SUCCESS:
    'api_invitation_code_preload_info_success',
  API_INVITATION_CODE_PRELOAD_INFO_ERROR:
    'api_invitation_code_preload_info_error',
  API_PRE_SIGN_UP_ERROR: 'api_pre_sign_up_error',
} as const;
